module.exports = __webpack_public_path__ + "img/404.a17f712.png";